import { Gutter } from 'antd/lib/grid/row';

export const CATEGORY4CONSTANTS = {
  GUTTER_VALUE: [15, 25] as Gutter,
  LABELS: {
    SUPPLIER: 'Supplier',
    TEMPERATURE_CONTROL: 'Temperature control',
    OWNED_VEHICLES: `Owned Vehicles (%)`,
    TRANSPORT_OWNED_BY_COMPANY:
      'Transport vehicle Completely owned by your company',
    TRANSPORTATION_VIA_AIR: 'Transportation is via air',
    TRANSPORTATION_COST: 'Transportation Cost',
    PRIMARY_MODE_OF_TRANSPORT: 'Primary Mode Of Transport',
    UNIT: 'Units',
  },
  FIELD_TRANSPORT_OWNED_BY_COMPANY: 'isCompletelyOwnedByCompany',
  FIELD_SUPPLIER: 'supplierId',
  FIELD_TEMPERATURE_CONTROL: 'temperatureControl',
  FIELD_OWNED_VEHICLES: 'ownedVehiclePercentage',
  FIELD_TRANSPORTATION_VIA_AIR: 'isTransportedByAir',
  FIELD_TRANSPORTATION_COST: 'transportationCost',
  FIELD_PRIMARY_MODE_OF_TRANSPORT: 'modeOfTransportation',
  FIELD_UNIT: 'unit',
  CATEGORY_NAME: 'category_4',
};

export const FINISHED_GOODS = {
  LABEL: {
    PRODUCT_NAME: 'Enter Finished Product Name',
    END_MARKET_LOCATION: 'End market location',
    PAID_BY_YOUR_COMPANY_TOGGLE: 'Paid by your company',
    QUANTITY_SHIPPED: 'Quantity shipped',
    UNIT: 'Unit',
    TEMPERATURE_CONTROL: 'Temperature control',
    PAID_BY_YOUR_COMPANY: `Paid by your company (%)`,
    TRANSPORTATION_VIA_AIR: 'Transportation is via air',
    TOTAL_WEIGHT_OF_ALL_GOODS: `Total Weight Of Finished Goods (kg)`,
    TOTAL_GOODS_TRANSPORTED: `Total goods transported (kg)`,
    GOODS_IN_STORAGE: `Goods in Storage (kg)`,
    GOODS_SOLD_VIA_ONLINE: `Goods sold via online retail (kg)`,
  },
  G: 'g',
  KG: 'kg',
  TONNE: 'tonnes',
  POUND: 'pounds',
};

export const currencyOptions = [
  { label: 'CAD', value: 'cad' },
  { label: 'EUR', value: 'eur' },
  { label: 'USD', value: 'usd' },
];

export const transportationModeOptions = [
  { label: 'Road', value: 'road' },
  { label: 'Rail', value: 'rail' },
  { label: 'Sea', value: 'sea' },
  { label: 'Air', value: 'air' },
];

export const quantityUnits = [
  { id: 1, label: 'kg', value: FINISHED_GOODS.KG },
  { id: 2, label: 'tonne', value: FINISHED_GOODS.TONNE },
  { id: 3, label: 'lb', value: FINISHED_GOODS.POUND },
];

export const commodityQuantityUnits = [
  { id: 1, label: 'g', value: FINISHED_GOODS.G },
  { id: 2, label: 'kg', value: FINISHED_GOODS.KG },
  { id: 3, label: 'tonnes', value: FINISHED_GOODS.TONNE },
  { id: 4, label: 'lb', value: FINISHED_GOODS.POUND },
];
